import React from "react";

export const AppTable = ({
  className = "",
  bordered = false,
  small = false,
  responsive = false,
  children,
  ...rest
}) => {
  const classes = [
    "app-table",
    bordered && "app-table-bordered",
    small && "app-table-sm",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const table = (
    <table className={classes} {...rest}>
      {children}
    </table>
  );

  return responsive ? <div className="table-responsive">{table}</div> : table;
};

export default AppTable;
